import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import {
  Row,
  Col,
  Grid,
  Panel,
  InputGroup,
  Button,
  Table,
  PanelBody,
  PanelHeader,
  FormControl,
  PanelContainer,
  Icon,
  FormGroup,
  ControlLabel,
  Form,
  Well,
} from '@sketchpixy/rubix';

import {getPatientsList, getServiceRegion} from '../../api/api';
import {routeUrl} from '../routeUrl';
import RoleType from '../RoleGroup/Roles/RoleType';
import {checkRole} from '../../util/RoleChecker';
import UserType from './UserType';

const INVALID_DATE = 'Invalid date';
const DATE_FORMAT = 'YYYY.MM.DD';

const tableStyle = {
  tableLayout: 'fixed'
};


class PatientListTable extends Component {
   constructor(props) {
      super(props);
     this.state = {
      datatables: null,
      search: {
        userType: UserType.USER.name,
        country: '',
        query:  '',
      }
    };
  }

  componentDidMount() {
        let self = this;
        let datatableDom = $(ReactDOM.findDOMNode(this.dataTable));
        if ($.fn.DataTable.isDataTable(datatableDom ) ) {
           return;
        }

        let datatables = datatableDom.addClass('nowrap')
          .DataTable({
            language: { infoFiltered: "" },
            processing: true,
            serverSide: true,
            responsive: true,
            searchDelay: 2000,
            searching: false,
            order: [[ 0, "desc" ]],
            pageLength: 100,
            lengthMenu: [
                  [ 10, 25, 50, 100, 200, 400],
                  [ '10', '25', '50', '100', '200', '400']
            ],
            ajax : function (data, callback, settings) {
               let search = self.state.search;
               let param = _.merge({}, data, search)
               getPatientsList(param, (err, result) => {
                   let rslt = result.patients;
                   rslt.data = self.assignData(rslt.data);
                   callback(rslt);
               });
            },
            columns: [
                {title: 'Id',                   data: 'patientId',                 name: 'patientId', width: '5%', className: "td-limit"},
                {title: 'Name',                data: 'patientName',               name: 'patientFirstName', width: '15%', className: "td-limit"},
                {title: 'Age',                 data : 'patientAge',                name: 'patientBirthday', width: '10%', className: "td-limit"},
                {title: 'Email',               data: 'patientEmail',              orderable: false, width: '15%', className: "td-limit"},
                {title: 'Diagnostics',        data: 'patientDiagnostics',       orderable: false, width: '10%', className: "td-limit"},
                {title: 'Join',                data: 'patientJoinDate',           name: 'patientSignupTime', width: '10%', className: "td-limit"},
                {title: 'Last trained date', data: 'patientLastTrainedDate',   name: 'exerciseMissionResultGeneratedTime', width: '10%', className: "td-limit"},
                {title: 'Expiration',         data: 'patientExpiration',         orderable: false, width: '10%', className: "td-limit"},
                {title: 'Detail',              data: 'patientDetail',             orderable: false, width: '10%', className: "td-limit"},
            ],
            rowId: 'patientId',
            select: true
        });

    $('#table tbody').on('click', 'tr', e => {
      let table = $('#table').DataTable();
      $(e.currentTarget).toggleClass('selected');
      let selected = table.row('.selected').data();
      this.props.onSelectRow(selected.patientId);
    });

    this.setState({
        datatables: datatables
     },() => {
        //self.doSearch();
     });

  }

  assignData(patients) {
    return patients.map(patient => {
      const name            = patient.patientNickname ? patient.patientNickname : `${patient.patientFirstName} ${patient.patientLastName}`;
      const age             = moment().diff(patient.patientBirthday, 'years');
      const patientJsondata = patient.patientJsondata ? JSON.parse(patient.patientJsondata) : null;
      let diagnosis         = (patientJsondata && patientJsondata.diagnosis) ? patientJsondata.diagnosis : null;
      let diagnostics       = (diagnosis && diagnosis !== null) ? diagnosis.replace(/"/gi, '') : '-';
      diagnostics           = diagnostics.length > 6 ? diagnostics.substr(0, 10) : diagnostics;

      const signupDate      = moment(patient.patientSignupTime).format(DATE_FORMAT);

      let lastTrainedTime   = moment(patient.exerciseMissionResultGeneratedTime);
      let lastTrainedDate   = moment(lastTrainedTime).format(DATE_FORMAT);
      lastTrainedDate       = lastTrainedDate === INVALID_DATE ? '-' : lastTrainedDate;
      const now             = moment();
      let unused            = lastTrainedTime.from(now);
      unused                = (unused !== INVALID_DATE) ? unused : 'never used';
      const lastTrained     = `${lastTrainedDate} (${unused})`;

      const subscriptionStartDate = moment(patient.patientSubscriptionStartTime).format(DATE_FORMAT) === INVALID_DATE ? 'No subscription data' : moment(patient.patientSubscriptionStartTime).format(DATE_FORMAT);
      const subscriptionEndDate   = moment(patient.patientSubscriptionEndTime).format(DATE_FORMAT) === INVALID_DATE ? null : moment(patient.patientSubscriptionEndTime).format(DATE_FORMAT);
      let expirationDate          = subscriptionEndDate ? `${subscriptionStartDate} ~ ${subscriptionEndDate}` : subscriptionStartDate;

      return {
        patientId:              patient.patientId,
        patientName:            name,
        patientAge:             age,
        patientEmail:           patient.patientEmail,
        patientDiagnostics:     diagnostics,
        patientJoinDate:        signupDate,
        patientLastTrainedDate: lastTrained,
        patientExpiration:      expirationDate,
        patientDetail:          '<a href="#">Detail</a>',
      };
    });
  }

  doSearch = (search) => {
    this.setState({ search: search }, () => {
      this.state.datatables.ajax.reload();
    });
  }

  render() {
    return (
        <Table id="table" ref={(c) => this.dataTable = c} className="display" cellSpacing="0" width="100%" style={tableStyle}/>
    );
  }
}

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: {
        userType: UserType.USER.name,
        country: '',
        query:  '',
      },
      roleRegion: 'ALL',
      role: null,
      serviceRegions: [],
    };
  }

  componentDidMount() {
    Messenger.options = {
      theme: 'flat',
    };

    getServiceRegion((err, result) => {
      if (err) {
        this.props.router.push(routeUrl.login);
      } else {
        this.setState({
          serviceRegions: result.list,
        });
      }
    });

    const requiredRoles = [
      RoleType.B2C_PATIENT_LIST,
      RoleType.B2C_PATIENT_LIST_READ_ONLY,
    ];

    checkRole(requiredRoles, this.props.router);

    let roles = JSON.parse(localStorage.getItem('roles'));
    let roleRegion = 'ALL';

    requiredRoles.forEach(requiredRoleType => {
      roles.forEach(role => {
        if (role.roleType && RoleType.enumValueOf(role.roleType.name) === requiredRoleType) {
          roleRegion = role.region;
        }
      });
    });

    this.setState({
      region: (roleRegion === 'ALL' ? '' : roleRegion),
    });
  }

  doSearch = (event) => {
    event.preventDefault();
    this.patientList.doSearch(this.state.search);
  }

  countryChangeHandler = (event) => {
     this.setState({ search: {...this.state.search, country: event.target.value} });
  };

  userTypeChangeHandler = (event) => {
    this.setState({ search: {...this.state.search, userType: event.target.value} });
  };


  queryChangeHandler = (event) => {
    let query = event.target.value;
    this.setState({ search: {...this.state.search, query: query} });
  };

  onSelectRow = (patientId) => {
    this.props.router.push(`${routeUrl.rapaelHomePatientsDetail}/${patientId}`);
  };

  render() {
    return (
        <PanelContainer noOverflow controls={false}>
          <Panel>
            <PanelHeader className='bg-pinkishred fg-white'>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <h3><Icon glyph='icon-fontello-users-1' />&nbsp; Patient list</h3>
                  </Col>
                </Row>
              </Grid>
            </PanelHeader>
            <PanelBody>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <Well>
                      <Form inline onSubmit={this.doSearch}>
                        <FormGroup controlId="countrySelect">
                          <ControlLabel style={{width: '120px', paddingLeft: '10px'}}>Country</ControlLabel>
                          <FormControl
                              disabled={this.state.roleRegion === 'ALL' ? false : 'disabled'}
                              componentClass="select"
                              onChange={this.countryChangeHandler}
                              value={this.state.search.region}
                              style={{width: '120px'}}>
                            <option value="">ALL</option>
                            {
                              this.state.serviceRegions.map(serviceRegion => (
                                  <option key={serviceRegion.countryId} value={serviceRegion.countryAlpha2Code}>
                                    {serviceRegion.countryAlpha3Code}
                                  </option>
                              ))
                            }
                          </FormControl>
                        </FormGroup>
                        <FormGroup controlId="typeSelect">
                          <ControlLabel style={{width: '120px', paddingLeft: '10px'}}>Type</ControlLabel>
                          <FormControl
                              componentClass="select"
                              onChange={this.userTypeChangeHandler}
                              style={{width: '120px'}}
                              value={this.state.search.user}>
                            <option value={UserType.USER.name}>User</option>
                            <option value={UserType.TESTER.name}>Tester</option>
                          </FormControl>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel style={{width: '120px', paddingLeft: '10px'}}>Search Word</ControlLabel>
                            <FormControl type='text' placeholder='Search Word' onChange={this.queryChangeHandler} style={{width: '120px'}}/>
                        </FormGroup>
                        <Button onClick={this.doSearch} className="pull-right">Search</Button>
                      </Form>
                    </Well>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <PatientListTable ref={(c) => this.patientList = c} onSelectRow={this.onSelectRow} />
                    <br />
                  </Col>
                </Row>
              </Grid>
            </PanelBody>
          </Panel>
        </PanelContainer>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/routes/patient/List.js